import { useOutletContext } from 'react-router-dom'
import { LiveJobsDashboard } from '../components/LiveJobsDashboard'
import { JobHistory } from '../components/JobHistory'

export function JobsPage() {
  const { socket } = useOutletContext()

  return (
    <>
      <section className="section">
        <h2>Live Job Activity</h2>
        <LiveJobsDashboard socket={socket} />
      </section>

      <section className="section">
        <h2>Sync Job History</h2>
        <JobHistory socket={socket} />
      </section>
    </>
  )
}
